/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const itemTypeSchema = z.enum(["food", "drink"]).describe("* `food` - Еда\n* `drink` - Напиток");
